export const ERROR_MESSAGES = {
  notFoundError: 'Page not found',
  networkError: 'Cannot connect to the server. Please check your internet connection.',
  defaultError: 'Something went wrong. Please contact developers to get it fixed.',
};
